<div class="legal-page">
  <header class="legal-header">
    <a routerLink="/landing" class="legal-header__brand">
      <div class="legal-header__logo"><mat-icon>point_of_sale</mat-icon></div>
      <span>Nova Point</span>
    </a>
    <a routerLink="/landing" class="legal-header__back">
      <mat-icon>arrow_back</mat-icon>
      Back to home
    </a>
  </header>

  <main class="legal-content">
    <h1>Privacy Policy</h1>
    <p class="legal-content__updated">Last updated: {{ lastUpdated }}</p>

    <!-- <div class="legal-notice">
      <mat-icon>info</mat-icon>
      <p>
        This is a draft policy template provided as a starting point. It has not been reviewed by
        legal counsel and should not be treated as your final, binding privacy policy until a
        qualified lawyer has reviewed it against your actual data practices and applicable law.
      </p>
    </div> -->

    <section>
      <h2>1. Introduction</h2>
      <p>
        Nova Point ("we", "us", "our") provides a point-of-sale and business management platform.
        This Privacy Policy explains what information we collect, how we use it, and the choices
        you have, when you use our website and application (the "Service").
      </p>
    </section>

    <section>
      <h2>2. Information We Collect</h2>
      <ul>
        <li><strong>Account information:</strong> name, username, email address, phone number, and password when you
          register.</li>
        <li><strong>Business data:</strong> shop details, products, inventory, orders, customers, and expenses you enter
          into the Service.</li>
        <li><strong>Transaction data:</strong> sales and subscription payment records, processed through our payment
          partners (e.g. Selcom, AzamPay).</li>
        <li><strong>Fiscal data:</strong> receipt data submitted to the Tanzania Revenue Authority (TRA) where fiscal
          device integration is enabled, as required by law.</li>
        <li><strong>Usage data:</strong> log data, device information, and how you interact with the Service.</li>
        <li><strong>Cookies:</strong> small files used to keep you signed in and remember preferences.</li>
      </ul>
    </section>

    <section>
      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To provide, maintain, and improve the Service.</li>
        <li>To process transactions and manage subscriptions.</li>
        <li>To comply with legal and tax-reporting obligations, including TRA fiscal reporting.</li>
        <li>To communicate with you about your account, updates, and support requests.</li>
        <li>To detect, prevent, and address fraud, abuse, and security issues.</li>
      </ul>
    </section>

    <section>
      <h2>4. How We Share Information</h2>
      <p>We do not sell your personal information. We share information only with:</p>
      <ul>
        <li>Payment processors (e.g. Selcom, AzamPay) to process subscription and sales payments.</li>
        <li>The Tanzania Revenue Authority, where fiscal receipt reporting is required.</li>
        <li>Infrastructure and hosting providers who help us operate the Service.</li>
        <li>Authorities, where required by law or to protect our rights and users.</li>
      </ul>
    </section>

    <section>
      <h2>5. Data Security</h2>
      <p>
        We use reasonable technical and organizational measures to protect your information,
        including encrypted connections and access controls. No method of transmission or storage
        is completely secure, and we cannot guarantee absolute security.
      </p>
    </section>

    <section>
      <h2>6. Data Retention</h2>
      <p>
        We retain account and business data for as long as your account is active, and afterward
        as needed to comply with legal, tax, or accounting obligations.
      </p>
    </section>

    <section>
      <h2>7. Your Rights</h2>
      <p>
        Depending on your location, you may have the right to access, correct, or request deletion
        of your personal information. Contact us using the details below to make a request.
      </p>
    </section>

    <section>
      <h2>8. Children's Privacy</h2>
      <p>The Service is intended for business use and is not directed at children under 18.</p>
    </section>

    <section>
      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will update the "Last updated" date
        above when we do.
      </p>
    </section>

    <section>
      <h2>10. Contact Us</h2>
      <p>
        Questions about this policy? Email us at
        <a href="mailto:us@support.akiliunde.com">us@support.akiliunde.com</a>.
      </p>
    </section>
  </main>
</div>